import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/app/index.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/demo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import StaffSelfRegistration from "components/smart-counter/StaffSelfRegistration";
import AdminLayout from "layouts/Admin.js";
import App from "components/login";

// IMPORT THE NEW PUBLIC COMPONENT
import CustomerSelfRegistration from "components/smart-counter/CustomerSelfRegistration"; 

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Switch>
      {/* 1. PUBLIC ROUTE (No Authentication Required) */}
      <Route path="/register" exact render={(props) => <CustomerSelfRegistration {...props} />} />
      <Route path="/register-staff" exact render={(props) => <StaffSelfRegistration {...props} />} />
      {/* 2. PROTECTED DASHBOARD ROUTES */}
      <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
      
      {/* 3. LOGIN / DEFAULT ROUTE */}
      <Route path="/" exact={true} component={App} />
    </Switch>
    <ToastContainer position="top-center" autoClose={3000} theme="light" />
  </BrowserRouter>
);
